import Index from 'src/pages/Products/WarehouseConfig/Index.vue'

const auth = { requiresAuth: true }

export default [
  {
    path: '/products/:id/warehouse_config',
    name: 'Warnschwellen & Sollmengen konfigurieren',
    component: Index,
    meta: auth
  }
]
